import { createReducer, on } from '@ngrx/store';
import * as SupervisorActions from './supervisor.actions';

export const supervisorFeatureKey = 'supervisor';

export interface SupervisorState {
  supervisors: Array<{ id: number; name: string }>;
  loading: boolean;
  error: string | null;
}

export const initialState: SupervisorState = {
  supervisors: [],
  loading: false,
  error: null,
};

export const supervisorReducer = createReducer(
  initialState,
  on(SupervisorActions.loadSupervisors, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(SupervisorActions.loadSupervisorsSuccess, (state, { supervisors }) => ({
    ...state,
    supervisors,
    loading: false,
    error: null,
  })),
  on(SupervisorActions.loadSupervisorsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);
